
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.296 15.332l1.085-1.078a.473.473 0 01.359-.148h1.521c1.26 0 1.845-.577 1.845-1.845V10.74c0-.148.043-.247.148-.36l1.078-1.084c.894-.888.887-1.712 0-2.599l-1.078-1.085a.459.459 0 01-.148-.352V3.732c0-1.254-.577-1.845-1.845-1.845H10.74a.467.467 0 01-.36-.141L9.297.668c-.888-.894-1.712-.887-2.599 0L5.612 1.746a.452.452 0 01-.352.14H3.732c-1.26 0-1.845.578-1.845 1.846V5.26c0 .141-.036.247-.141.352L.668 6.697c-.894.887-.887 1.711 0 2.599l1.078 1.085c.105.112.14.21.14.359v1.521c0 1.26.585 1.845 1.846 1.845H5.26c.141 0 .247.043.352.148l1.085 1.078c.887.894 1.711.887 2.599 0zm-2.486-3.79c-.219 0-.36-.07-.465-.19L3.993 8.74a.61.61 0 01-.155-.402c0-.331.253-.577.612-.577.19 0 .331.063.458.197l1.867 2.063 3.627-5.106c.14-.204.281-.289.528-.289.345 0 .592.254.592.585 0 .12-.05.26-.127.373l-4.106 5.74a.587.587 0 01-.48.219z","fill":"#0089CF","fill-rule":"nonzero"}})])
          )
        }
      }
    